'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var animated = {
  padding: '16px',
  backgroundColor: '#F6F7F8',
  height: '52px',
  marginBottom: '16px',
  borderRadius: '4px',
  width: '300px'
};
var normal = {
  height: '40px',
  background: 'white',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'grey.01',
  borderRadius: '4px',
  padding: '10px 12px',
  width: '300px',
  // cursor: 'pointer',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  fontSize: '13px',
  color: 'grey.10'
};
var input = {
  animated: animated,
  normal: normal
};

exports.default = input;
